import { useEffect, useState } from 'react';
import type { RedesSocialesProfe, RedesSocialesProfeProps } from '@/types';
import { safeFetch } from '@/api/safeFetch';

const RedesSocialesProfe: React.FC<RedesSocialesProfeProps> = ({ perfil_id, servicio_name, profesional_name }) => {

  const [redesSociales, setRedesSociales] = useState<RedesSocialesProfe[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // 🔹 Iconos de redes sociales
  const socialMediaIcons: { [key: string]: string } = {
    facebook: '/img/redesSociales/facebook.png',
    instagram: '/img/redesSociales/instagram.png',
    tiktok: '/img/redesSociales/tiktok.png',
    twitter: '/img/redesSociales/twitter.png',
  };

  useEffect(() => {
    if (!perfil_id) return; // ✅ Evitar fetch con perfil_id inválido

    const fetchRedesSociales = async () => {
      try {
        const response = await safeFetch(`/api/profesional/${servicio_name}/${profesional_name}/${perfil_id}/redes_sociales`);
        if (!response.ok) throw new Error('Error al cargar las redes sociales');
        const data: RedesSocialesProfe[] = await response.json();
        setRedesSociales(data);
      } catch (error: unknown) {
        setError((error as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchRedesSociales();
  }, [perfil_id, servicio_name, profesional_name]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  // Filtramos redes que tengan enlace válido
  const redesValidas = redesSociales.filter(red => red.enlace && red.enlace.trim() !== '');

  return (
    <div className="flex flex-col lg:flex-col lg:items-center lg:justify-between items-center lg:ml-4 mt-8 lg:mt-0">
      <div className="flex flex-row justify-center items-center space-x-4 mt-4 w-full">
        {redesValidas.length > 0 ? (
          redesValidas.map((red) => {
            // Normalizamos el nombre a minúsculas y usamos fallback si el icono no existe
            const iconSrc = socialMediaIcons[red.nombre.toLowerCase()] || '/img/redesSociales/default.png';

            return (
              <a href={red.enlace} key={red.nombre} target="_blank" rel="noopener noreferrer">
                <img
                  src={iconSrc}
                  className="h-10 w-10"
                  alt={red.nombre}
                  onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/img/redesSociales/default.png'; }}
                />
              </a>
            );
          })
        ) : (
          <p className="text-zinc-600">Redes sociales no disponibles.</p>
        )}
      </div>
    </div>
  );
};

export default RedesSocialesProfe;